import { IonContent } from '@ionic/react';
import { ReactNode, useEffect } from 'react';
import { useUserState } from '../../../hooks/context/useUserState';
import Sidebar from '../../../components/Sidebar/Sidebar';
import { useRouteTransitionContext } from '../../../hooks/context/useRouteTransitionContext';

interface ContentProps {
  children: ReactNode;
  peersets?: any[];
  isLoading?: boolean;
  onMenuItemClick?: (url: string) => void;
}

const Content = ({
  children,
  isLoading,
  peersets,
  onMenuItemClick,
}: ContentProps) => {
  const {
    state: { username, menuItems },
  } = useUserState();
  const { requestBusy, releaseBusy } = useRouteTransitionContext();

  // Report this page's loading so an open transition session stays up until the
  // destination (incl. a redirect target like filterFirst) is ready. The
  // overlay itself is rendered once in LoggedInLayout (RouteTransitionOverlay).
  useEffect(() => {
    if (!isLoading) {
      return;
    }
    requestBusy();
    return releaseBusy;
  }, [isLoading, requestBusy, releaseBusy]);

  return (
    <IonContent className="content-main">
      <div className="content-and-sidebar">
        {username && menuItems && menuItems.length && (
          <Sidebar
            menuItems={menuItems}
            peersets={peersets}
            onMenuItemClick={onMenuItemClick}
          />
        )}
        <div className="page-content-container">{!isLoading && children}</div>
      </div>
    </IonContent>
  );
};

export default Content;
